import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';

import ExpandableSectionHeader from "./ExpandableSectionHeader";

const CompanyInfoForm = () => {
  const {
    values, setValues, formErrors, collapseValues, setCollapseValue, sectionStyle
  } = useContext(ProposalInputContext);

  return (
    <Grid container spacing={2} sx={sectionStyle}>
      <ExpandableSectionHeader
        sectionTitle='2. Company Information'
        showSection='showCompanyInfo'
        icon={<ApartmentOutlinedIcon sx={{ color: "text.secondary" }} />}
        collapseValues={collapseValues}
        setCollapseValue={setCollapseValue}
      />

      {collapseValues?.showCompanyInfo &&
        <>
          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Company name *"
              name='accountName'
              value={values?.accountName}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  accountName: e.target.value
                }))
              }
              helperText={formErrors['accountName']}
              error={'accountName' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Registered company number *"
              name='uniqueCompanyId'
              value={values?.uniqueCompanyId}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  uniqueCompanyId: e.target.value
                }))
              }
              helperText={formErrors['uniqueCompanyId']}
              error={'uniqueCompanyId' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <TextField
              variant="outlined"
              label="Company address *"
              name='companyAddress'
              value={values?.companyAddress}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  companyAddress: e.target.value
                }))
              }
              multiline
              rows={2}
              helperText={formErrors['companyAddress']}
              error={'companyAddress' in formErrors}
              fullWidth
            />
          </Grid>
        </>
      }
    </Grid>
  );
};

export default CompanyInfoForm;